export default "__VITE_ASSET__YCCSyeiy__"